const NotFountPage = (props) => {
	return (
		<h1 className='text-red-500 my-16 text-center text-5xl uppercase'>
			{' '}
			404 We're sorry this content isn't variable
		</h1>
	);
};

export default NotFountPage;
